export default {
    methods: {
        getSpotId() {
            const params = new URLSearchParams(window.location.search)
            return params.get('s');
        },
        setSpotId(payload) {
            if (!this.categoryId) {
                window.history.replaceState(null, null, window.location.pathname + "?s=" + payload);
            } else {
                window.history.replaceState(null, null, window.location.pathname + "?s=" + payload + "&c=" + this.categoryId);
            }
        },
        deleteSpotId() {
            if (!this.categoryId) {
                window.history.replaceState(null, null, window.location.pathname);
            } else {
                window.history.replaceState(null, null, window.location.pathname + "?c=" + this.categoryId);
            }
        }
    }
};